// @flow
import { keyframes, css } from "styled-components";

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(2.5em);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const questionWrapperStyles = css`
  max-width: 550px;
  margin-left: auto;
  margin-right: auto;
  padding: 40px 20px 80px;

  animation: 0.7s ${fadeIn} ease;
`;

export type Props = {|
  className?: string,
  children: React$Node,
  css?: any,
  next?: (e: SyntheticInputEvent<HTMLFormElement>) => void,
  dataTest?: string,
  "data-test"?: string,
|};

export const QuestionWrapper = ({
  children,
  className,
  next,
  dataTest,
}: Props) => (
  <form
    className={className}
    data-test={dataTest}
    css={questionWrapperStyles}
    onSubmit={(e) => {
      e.preventDefault();
      if (next) next(e);
    }}
  >
    {children}
  </form>
);
